<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" class="text-center text-sm-right">
        <v-btn large router to="/search" class="info">
          Explore Items
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6" class="text-center text-sm-left">
        <v-btn large router @click="$root.$refs.AppBar.openListingDialog();" class="info">
          List an Item
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col cols="12">
        <v-carousel style="cursor: pointer;">
          <v-carousel-item
            v-for="item in items"
            :key="item.id"
            :src="item.images[0]"
            @click="onLoadItem(item.id)"
          >
            <div class="title">
              {{ item.title }}
            </div>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
    <!--   <v-row class="mt-2">
      <v-col
        cols="12"
        class="text-center"
      >
        <p>Join our awesome meetups!</p>
      </v-col>
    </v-row>  -->
  </v-container>
</template>

<script>
export default {
  name: 'FeaturedItems',

  computed: {
    items() {
      return this.$store.getters.featuredItems
    },
    loading() {
      return this.$store.getters.loading
    }
  },
  methods: {
    onLoadItem(id) {
      this.$router.push('/items/' + id)
    }
  }
}
</script>
